export default function HeroSection() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{
          backgroundImage:
            "url('https://public.readdy.ai/ai/img_res/2dd0611677b7c7efc057c08d29afa71b.jpg')",
        }}
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-black/60 via-black/40 to-black/55" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 md:px-10 text-center">
        <p
          className="text-xs md:text-sm uppercase tracking-[0.25em] text-white/60 mb-6 font-medium"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          KOREN d.o.o.
        </p>
        <h1
          className="text-4xl sm:text-5xl md:text-7xl font-bold text-white leading-tight mb-6"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          Modern iOS Apps
          <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-300 to-teal-400">
            Built for Security
          </span>
        </h1>
        <p className="text-base md:text-xl text-white/70 max-w-2xl mx-auto leading-relaxed">
          We craft powerful iOS applications that protect your privacy, optimize your device,
          and elevate your mobile experience to the next level.
        </p>

        {/* Scroll indicator */}
        <div className="mt-16 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-white/40 text-xs tracking-widest uppercase">Scroll</span>
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-down-line text-white/40 text-lg" />
          </div>
        </div>
      </div>
    </section>
  );
}
